import { Cpu, Leaf, Users, Droplet } from "lucide-react";
import { usePublicLang } from "@/contexts/PublicLangContext";

// Fix B (2026-09-04): barra de atributos de marca que en el manual va
// inmediatamente debajo del hero. Contenido fijo de marca (no depende de
// datos de la clinica), con iconos de linea fina en oro.
const ITEMS = [
  { icon: Cpu, key: "tech" },
  { icon: Leaf, key: "natural" },
  { icon: Users, key: "personalized" },
  { icon: Droplet, key: "experts" },
];

export default function TrustBar() {
  const { t } = usePublicLang();
  return (
    <section className="bg-white/60 border-y border-[rgba(185,154,98,0.22)]" data-testid="landing-trustbar">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-[rgba(185,154,98,0.18)]">
        {ITEMS.map(({ icon: Icon, key }) => (
          <div key={key} className="flex items-center gap-3 px-5 py-6 md:py-7">
            <Icon className="w-5 h-5 shrink-0 text-[var(--brand-primary)]" strokeWidth={1.25} />
            <span className="text-[10px] md:text-[11px] uppercase tracking-[0.16em] leading-snug text-[#6B6058]">
              {t(`landing.trust.${key}`)}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
